var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"units"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"btn-group filter-group"},[_c('button',{staticClass:"btn",class:[
          {
            'btn-action-selected-yamaha':
              _vm.selectedFilter == 'All' && _vm.brand == 'yamaha',
          },
          {
            'btn-action-selected-husky':
              _vm.selectedFilter == 'All' && _vm.brand == 'husky',
          },
          {
            'btn-action-selected-ktm':
              _vm.selectedFilter == 'All' && _vm.brand == 'ktm',
          },
          ("btn-action-outline-" + _vm.brand) ],attrs:{"type":"button"},on:{"click":function($event){return _vm.setFilteredUnits('All')}}},[_vm._v("\n        "+_vm._s(_vm.$t('message.allUnits'))+"\n      ")]),(_vm.filters.includes('Frame'))?_c('button',{staticClass:"btn",class:[
          {
            'btn-action-selected-yamaha':
              _vm.selectedFilter == 'Frame' && _vm.brand == 'yamaha',
          },
          {
            'btn-action-selected-husky':
              _vm.selectedFilter == 'Frame' && _vm.brand == 'husky',
          },
          {
            'btn-action-selected-ktm':
              _vm.selectedFilter == 'Frame' && _vm.brand == 'ktm',
          },
          ("btn-action-outline-" + _vm.brand) ],attrs:{"type":"button"},on:{"click":function($event){return _vm.setFilteredUnits('Frame')}}},[_vm._v("\n        "+_vm._s(_vm.$t('message.frame'))+"\n      ")]):_vm._e(),(_vm.filters.includes('Engine'))?_c('button',{staticClass:"btn",class:[
          {
            'btn-action-selected-yamaha':
              _vm.selectedFilter == 'Engine' && _vm.brand == 'yamaha',
          },
          {
            'btn-action-selected-husky':
              _vm.selectedFilter == 'Engine' && _vm.brand == 'husky',
          },
          {
            'btn-action-selected-ktm':
              _vm.selectedFilter == 'Engine' && _vm.brand == 'ktm',
          },
          ("btn-action-outline-" + _vm.brand) ],attrs:{"type":"button"},on:{"click":function($event){return _vm.setFilteredUnits('Engine')}}},[_vm._v("\n        "+_vm._s(_vm.$t('message.engine'))+"\n      ")]):_vm._e(),(_vm.filters.includes('Other'))?_c('button',{staticClass:"btn btn-action-outline",class:[
          {
            'btn-action-selected-yamaha':
              _vm.selectedFilter == 'Other' && _vm.brand == 'yamaha',
          },
          {
            'btn-action-selected-husky':
              _vm.selectedFilter == 'Other' && _vm.brand == 'husky',
          },
          {
            'btn-action-selected-ktm':
              _vm.selectedFilter == 'Other' && _vm.brand == 'ktm',
          },
          ("btn-action-outline-" + _vm.brand) ],attrs:{"type":"button"},on:{"click":function($event){return _vm.setFilteredUnits('Other')}}},[_vm._v("\n        "+_vm._s(_vm.$t('message.otherUnits'))+"\n      ")]):_vm._e()])]),_c('div',{staticClass:"row"},_vm._l((_vm.filteredUnits),function(unit,index){return _c('div',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#app'),expression:"'#app'"}],key:index,staticClass:"col-sm-3 col-xs-4",on:{"click":function($event){return _vm.selectUnit({
          selectedUnit: {
            name: unit.name,
            id: unit.id,
            illustUrl: unit.illustUrl,
          },
        })}}},[_c('div',{staticClass:"panel panel-default panel-unit",class:(_vm.brand + "-border-hover")},[_c('div',{staticClass:"panel-body"},[(_vm.brand === 'kawasaki')?_c('img',{staticClass:"img-responsive img-unit",attrs:{"src":unit.iconUrl,"onerror":"this.onerror=null;this.src='https://i.imgur.com/lQfiJGA.gif';","alt":"Unit"}}):_c('zoom-on-hover',{staticClass:"img-responsive img-unit",attrs:{"img-normal":unit.iconUrl,"img-zoom":unit.illustUrl,"onerror":"this.onerror=null;this.src='https://i.imgur.com/lQfiJGA.gif';","alt":"Unit","scale":1.1}})],1),_c('div',{staticClass:"panel-footer"},[_vm._v(_vm._s(unit.name))])])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }